import { OverlayViewF, FLOAT_PANE } from "@react-google-maps/api";
import { EditableFence } from "./types";
import { centroidOf } from "./mapUtils";

const centreOffset = (width: number, height: number) => ({
  x: -width / 2,
  y: -height / 2,
});

/** Name tag floated over a fence's centre. Pointer events pass through to the polygon. */
const FenceLabel = ({ fence }: { fence: EditableFence }) => (
  <OverlayViewF
    position={centroidOf(fence.coordinates)}
    mapPaneName={FLOAT_PANE}
    getPixelPositionOffset={centreOffset}
  >
    <div className="pointer-events-none whitespace-nowrap rounded bg-gray-900/85 px-2 py-0.5 text-xs font-semibold text-white shadow">
      {fence.name || <span className="italic font-normal">Unnamed fence</span>}
    </div>
  </OverlayViewF>
);

export default FenceLabel;
